import React from "react";
import styled from "styled-components";

const StyledBox = styled.div`
  margin: 1rem 0 4rem;
  padding: 1rem;
  background-color: rgb(250, 251, 252);
  box-shadow: 0 2px 8px 0 rgba(0, 75, 123, 0.2);
  border-radius: 0.3125rem;
`;

interface IFormBoxProps {
  children: React.ReactNode;
}

const FormBox = (props: IFormBoxProps) => {
  const { children } = props;
  return <StyledBox>{children}</StyledBox>;
};

export default FormBox;
